import { ViewIds } from '@ardoq/api-types';
import { LayoutDescriptor, LayoutGraph } from '@ardoq/yfiles';
import { getLayoutAlgorithm } from './getLayoutAlgorithm';

const workerApplyLayout = (
  viewId: ViewIds,
  graph: LayoutGraph,
  layoutDescriptor: LayoutDescriptor
) => getLayoutAlgorithm(viewId, layoutDescriptor)?.applyLayout(graph);

export { workerApplyLayout };
